<template>
  <div
    v-if="showLoading"
    class="global-filter-loading"
  >
    <a-spin size="large" />
    <div class="global-filter-loading__text">数据定位中，请稍候……</div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

interface Props {
  visible: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  visible: false,
});

const showLoading = ref(false);
const startTime = ref(0);
const minDisplayTime = 1000; // 至少显示2秒
let showTimer = null;
watch(
  () => props.visible,
  newVal => {
    if (newVal) {
      // 超过0.5秒才显示
      showTimer = setTimeout(() => {
        showTimer = null;
        startTime.value = Date.now();
        showLoading.value = true;
      }, 500);
    } else {
      // 如果已经显示了loading，至少显示2秒
      if (showTimer) {
        clearTimeout(showTimer);
      }
      if (!showLoading.value) {
        return;
      }
      const elapsed = Date.now() - startTime.value;
      const remaining = minDisplayTime - elapsed;
      if (remaining > 0) {
        setTimeout(() => {
          showLoading.value = false;
        }, remaining);
      } else {
        showLoading.value = false;
      }
    }
  },
);
</script>

<style scoped lang="less">
.global-filter-loading {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.65);

  &__text {
    color: #333;
    font-size: 14px;
  }
}
</style>
